import { ProductBatchTypeEnum } from '@c2b/muven-commons'
import { ChannelModel } from '../../channel/models/ChannelModel';
import { StoreModel } from '../../store/models/StoreModel';
import { ProductBatchPricePercentageManagementByChannelModel } from './ProductBatchPricePercentageManagementByChannelModel';
import { ProductBatchPriceValueManagementByChannelModel } from './ProductBatchPriceValueManagementByChannelModel';
import { ProductBatchStockManagementByStoreModel } from './ProductBatchStockManagementByStoreModel';
import { ProductBatchStockPercentageManagementByChannelModel } from './ProductBatchStockPercentageManagementByChannelModel';

interface BatchTypeWrapper {
    enum: ProductBatchTypeEnum;
    description: string;
}

export class ProductBatchModel {

    static getBatchTypeOptions(publicKey?: string): BatchTypeWrapper[] {

        const batchTypeOpts =  [
            {
                enum: ProductBatchTypeEnum.UpdateChannelPriceValue,
                description: 'Controle de PREÇO FIXO por canal',
            },
            {
                enum: ProductBatchTypeEnum.UpdateChannelPricePercentage,
                description: 'Controle de PREÇO CALCULADO por canal',
            },
            {
                enum: ProductBatchTypeEnum.BlockStock,
                description: 'Gerenciamento de ESTOQUE por loja',
            },
            {
                enum: ProductBatchTypeEnum.UpdateChannelStockPercentage,
                description: 'Controle de PERCENTUAL de ESTOQUE por canal',
            },
        ];

        // if (publicKey === 'e7aeb9a159536f8c9bde05fbeca239b8' || publicKey === 'rafael-c2b-hml') {
        //     batchTypeOpts.push({
        //         enum: ProductBatchTypeEnum.UpdateChannelStockPercentage,
        //         description: 'Controle de PERCENTUAL de ESTOQUE por canal',
        //     });
        // }
        return batchTypeOpts;
    }

    id?: number = undefined;
    name: string = '';
    description: string = '';
    batchType: ProductBatchTypeEnum | null = null;
    batchTypeWrapper: BatchTypeWrapper | null = null;
    isBeingModified: boolean = false;
    isLoading: boolean = false;
    createdAt: Date | string = '';
    updatedAt: Date | string = '';
    payload: {
        [key: string]: any;
    } = {};

    constructor(b?: Partial<ProductBatchModel>) {
        Object.assign(this, b)

        this.isLoading = false
        this.isBeingModified = false
        this._parseDate()
        this._parseExecutionPayload()
    }

    getBatchTypeDescription(): string {
        switch (this.batchType) {
            case ProductBatchTypeEnum.BlockStock:
                return "Estoque";

            case ProductBatchTypeEnum.UpdateChannelPriceValue:
                return "Preço fixo";

            case ProductBatchTypeEnum.UpdateChannelPricePercentage:
                return "Preço calculado";

            case ProductBatchTypeEnum.UpdateChannelStockPercentage:
                return "Percentual de estoque";

            default:
                return "";
        }
    }

    isNew(): boolean {
        return !this.id
    }

    isEqual(batch: ProductBatchModel): boolean {
        if (!(batch instanceof ProductBatchModel)) {
            return false
        }

        if (!batch.id) {
            return false
        }

        return String(this.id) === String(batch.id)
    }

    shouldShowChannel(): boolean {
        return this.isBatchTypePricePercentageManagement();
    }

    isValid(): boolean {
        if (this.isNew()) {
            if (this.isBatchTypeStockManagement()) {
                return !!this.name &&
                    !!this.description &&
                    (this.batchType !== undefined)
            }

            if (this.isBatchTypePriceValueManagement()) {
                return !!this.name &&
                    !!this.description &&
                    (this.batchType !== undefined) &&
                    !!this.payload?.idStore
            }

            if (this.isBatchTypePricePercentageManagement()) {
                return !!this.name &&
                    !!this.description &&
                    (this.batchType !== undefined) &&
                    !!this.payload?.idChannel
            }

            if (this.ifBatchTypeStockPercentageManagement()) {
                return !!this.name &&
                    !!this.description &&
                    (this.batchType !== undefined)
            }

            return false
        }

        return !!this.name &&
            !!this.description
    }

    isBatchTypeStockManagement(): boolean {
        return this.batchType === ProductBatchTypeEnum.BlockStock;
    }

    isBatchTypePriceValueManagement(): boolean {
        return this.batchType === ProductBatchTypeEnum.UpdateChannelPriceValue;
    }

    isBatchTypePricePercentageManagement(): boolean {
        return this.batchType === ProductBatchTypeEnum.UpdateChannelPricePercentage;
    }

    ifBatchTypeStockPercentageManagement(): boolean {
        return this.batchType === ProductBatchTypeEnum.UpdateChannelStockPercentage;
    }

    updateStore(store: StoreModel): void {
        this.payload.idStore = store.id
    }

    updateChannel(channel: ChannelModel): void {
        this.payload.idChannel = channel.id
    }

    updateBatchType(bt: BatchTypeWrapper): void {
        this.batchType = bt.enum
        this._parseExecutionPayload();
    }

    private _parseDate(): void {
        if (!!this.createdAt) {
            this.createdAt = new Date(this.createdAt)
        }

        if (!!this.updatedAt) {
            this.updatedAt = new Date(this.updatedAt)
        }
    }

    private _parseExecutionPayload(): void {
        switch (this.batchType) {
            case ProductBatchTypeEnum.BlockStock:
                this.payload = new ProductBatchStockManagementByStoreModel(this.payload)
                break;

            case ProductBatchTypeEnum.UpdateChannelPriceValue:
                this.payload = new ProductBatchPriceValueManagementByChannelModel(this.payload)
                break;

            case ProductBatchTypeEnum.UpdateChannelPricePercentage:
                this.payload = new ProductBatchPricePercentageManagementByChannelModel(this.payload)
                break;

            case ProductBatchTypeEnum.UpdateChannelStockPercentage:
                this.payload = new ProductBatchStockPercentageManagementByChannelModel(this.payload);
                break;
        }
    }
}
